<ps-ui-modal class="psid-modal">
  <ps-ui-modal-title>
    <i
      class="fa fa-exclamation-circle exclamationStyle"
      aria-hidden="true"
      *ngIf="isClearRequest"
    ></i>
  </ps-ui-modal-title>
  <ps-ui-modal-body>
    <div class="psid-modal-data col-xs-12 col-sm-8 col-md-8 col-md-offset-2">
      <p class="uploadText" *ngIf="!isClearRequest">Latest uploads</p>
      <p class="lableText">
        {{
          isClearRequest
            ? 'Are you sure you want to clear PSIDs?'
            : psidsToDisplay
        }}
      </p>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer *ngIf="isClearRequest">
    <button
      type="button"
      psUiButton
      color="secondary"
      class="cancleBtn"
      (click)="close()"
    >
      Close
    </button>
    <button
      type="button"
      class="clearBtn"
      psUiButton
      (click)="clearUploadedPSIDs()"
    >
      Ok
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
